import { z } from 'zod'
import { Model } from './architecture'

export const CountValidation = z.object({
  value: z.number({ required_error: '[Count] value is required' }).min(0),
})

export class Count extends Model {
  static create({ value }: z.infer<typeof CountValidation>) {
    CountValidation.parse({ value })
    return new Count(value)
  }

  static empty() {
    return new Count(0)
  }

  static fromNumber(num: number) {
    return Count.create({ value: num })
  }

  static fromNumberOrUndefined(num?: number) {
    if (!num) {
      return undefined
    }

    return Count.create({ value: num })
  }

  constructor(private readonly _value: number) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
